import type { CoverSheetConfigCard } from '../../types';

export const mlsInformationCard = {
  id: 'propertyInfo.mlsInformation',
  innerTitle: 'MLS Information',
  layout: [
    [
      {
        name: 'mlsAutofill',
        size: 100,
      },
    ],
  ],
  fields: {
    mlsServiceId: {
      name: 'property.mlsServiceId',
      entity: 'property',
      label: 'MLS Vendor',
      type: 'hidden',
    },
    mlsNumber: {
      name: 'property.mlsNumber',
      entity: 'property',
      label: 'MLS Number',
      type: 'hidden',
    },
    mlsAutofill: {
      name: 'mlsAutofill',
      type: 'mlsAutofill',
      label: 'MLS AUTOFILL',
      action: {
        name: 'mlsAutofill',
        mlsAutofillFields: {
          vendorId: 'property.mlsServiceId',
          number: 'property.mlsNumber',
        },
        props: [
          {
            from: 'property.assessorParcelNumber',
            to: 'property.taxIdNumber',
          },
          {
            from: 'property.legalDescription',
            to: 'property.legalDescription',
          },
          {
            from: 'property.bedrooms',
            to: 'property.bedrooms',
          },
          {
            from: 'property.bathrooms',
            to: 'property.bathrooms',
          },
          {
            from: 'property.buildingArea',
            to: 'property.buildingArea',
          },
          {
            from: 'property.lotSize',
            to: 'property.lotSize',
          },
          {
            from: 'property.type',
            to: 'property.type',
          },
          {
            from: 'property.transactionType',
            to: 'property.transactionType',
          },
          {
            from: 'photos',
            to: 'photos',
          },
          {
            from: 'description',
            to: 'insideListingDescription',
          },
          {
            from: 'tourUrl',
            to: 'tourUrl',
          },
        ],
      },
    },
  },
} satisfies CoverSheetConfigCard;
